import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { sendContratoByEmail } from "../../../redux/actions/contrato";
import FormikTextField from "../../commons/formik/FormikTextField";
import CircularLoading from "../../commons/loading/CircularLoading";
import { StyledModalSendEmail } from "../../styled/Empresa";


const initialValues = {
  email: "",
};

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Debe escribir un formato de email valido")
    .required("Este campo es obligatorio"),
});

export default function ModalSendEmail({ open, handleClose, codigoContrato }) {

  const dispatch = useDispatch();
  const handleSumbit = ({ email }) => {
    dispatch(sendContratoByEmail(codigoContrato, email)).then((response) => {
      toast.success("Contrato enviado correctamente");
      handleClose();
    });
  };
  const contratoEmail = useSelector((state) => state.contrato.contratoEmail);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        {!contratoEmail.loading ? "Enviar contrato por Email" : "Enviando..."}
      </DialogTitle>

      {!contratoEmail.loading ? (
        <StyledModalSendEmail.ContainerBody>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSumbit}
          >
            {({ errors, touched, values }) => (
              <Form>
                <StyledModalSendEmail.FormikFieldContainer>
                  <FormikTextField
                    fullWidth={true}
                    id="email"
                    name="email"
                    type="text"
                    label="Email"
                  />
                </StyledModalSendEmail.FormikFieldContainer>
                <StyledModalSendEmail.ContainerButtons>
                  <Button type="button" onClick={handleClose}>
                    Cancelar
                  </Button>
                  <Button type="submit" variant="contained" color="primary">
                    Enviar
                  </Button>
                </StyledModalSendEmail.ContainerButtons>
              </Form>
            )}
          </Formik>
        </StyledModalSendEmail.ContainerBody>
      ) : (
        <StyledModalSendEmail.ContainerBody>
          <CircularLoading />
        </StyledModalSendEmail.ContainerBody>
      )}
    </Dialog>
  );
}
